import { useState } from 'react';
import LiveFeed from './LiveFeed';

export default function MobileBottomNav({ view, setView, onHomeClick, onActivityClick, user, onSignInRequired }) {
  const [liveOpen, setLiveOpen] = useState(false);
  const activeView = view === 'home' || view === 'search' || view === 'highlight' ? 'home' : view;

  const handleNav = (id) => {
    if (id === 'home' && onHomeClick) onHomeClick();
    else setView(id);
  };

  const isGuest = user?.isAnonymous || user?.provider === 'anon';

  return (
    <>
      <nav
        className="mobile-bottom-nav"
        style={{
          position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 800,
          background: 'var(--bg)',
          backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
          borderTop: '1px solid var(--border)',
          display: 'flex', alignItems: 'center', justifyContent: 'space-around',
          padding: '6px 4px calc(6px + env(safe-area-inset-bottom))',
        }}
      >
        {/* Home */}
        <NavBtn
          label="Home" active={activeView === 'home'}
          onClick={() => handleNav('home')}
          icon={(active) => (
            <svg width="22" height="22" viewBox="0 0 24 24" fill={active ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
          )}
        />

        {/* Live Activity */}
        <NavBtn
          label="Live" active={liveOpen} dataTour="live-mobile"
          onClick={() => setLiveOpen(v => !v)}
          icon={(active) => (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" fill={active ? 'currentColor' : 'none'} />
            </svg>
          )}
        />

        {/* Saved */}
        <NavBtn
          label="Saved" active={activeView === 'saved-kahanis'}
          onClick={() => handleNav('saved-kahanis')}
          icon={(active) => (
            <svg width="22" height="22" viewBox="0 0 24 24" fill={active ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2">
              <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
            </svg>
          )}
        />

        {/* My Kahani */}
        <NavBtn
          label="My Kahani" active={activeView === 'my-kahani'} dataTour="share-mobile"
          onClick={() => handleNav('my-kahani')}
          icon={(active) => (
            <svg width="22" height="22" viewBox="0 0 24 24" fill={active ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
          )}
        />
      </nav>

      {/* Live Activity drawer */}
      {liveOpen && (
        <>
          <div
            onClick={() => setLiveOpen(false)}
            style={{
              position: 'fixed', inset: 0, zIndex: 840,
              background: 'rgba(0,0,0,0.3)',
            }}
          />
          <div style={{
            position: 'fixed', left: 0, right: 0,
            bottom: 'calc(56px + env(safe-area-inset-bottom))',
            zIndex: 850,
            background: 'var(--bg)',
            borderRadius: '18px 18px 0 0',
            boxShadow: '0 -8px 32px rgba(0,0,0,0.12)',
            maxHeight: 'calc(75vh - 56px)',
            display: 'flex', flexDirection: 'column',
            overflow: 'hidden',
            animation: 'slideUp 0.22s ease-out',
          }}>
            {/* Sticky header */}
            <div style={{
              flexShrink: 0,
              padding: '12px 18px 10px',
              borderBottom: '1px solid var(--border)',
              background: 'var(--bg)',
            }}>
              <div style={{ width: 36, height: 4, borderRadius: 2, background: 'var(--border)', margin: '0 auto 12px' }} />
              <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 1 }}>
                ⚡ Live Activity
              </div>
            </div>
            {/* Scrollable content */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '0 18px 16px' }}>
              <LiveFeed
                onActivityClick={(item) => { setLiveOpen(false); if (onActivityClick) onActivityClick(item); }}
                isGuest={isGuest}
                onSignInRequired={() => { setLiveOpen(false); if (onSignInRequired) onSignInRequired(); }}
              />
            </div>
          </div>
          <style>{`@keyframes slideUp { from { transform: translateY(100%); opacity: 0; } to { transform: translateY(0); opacity: 1; } }`}</style>
        </>
      )}
    </>
  );
}

function NavBtn({ label, active, onClick, icon, dataTour }) {
  return (
    <button
      onClick={onClick}
      data-tour={dataTour}
      style={{
        flex: 1, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: 2,
        background: 'none', border: 'none', cursor: 'pointer', padding: '6px 4px',
        color: active ? 'var(--blue)' : 'var(--text3)',
        fontFamily: 'var(--sans)', fontSize: 10,
        fontWeight: active ? 700 : 500, transition: 'all 0.15s',
        borderRadius: 10, position: 'relative',
      }}
      aria-label={label}
    >
      {active && (
        <div style={{
          position: 'absolute', top: 0, left: '50%',
          transform: 'translateX(-50%)',
          width: 32, height: 3, borderRadius: '0 0 3px 3px', background: 'var(--blue)',
        }} />
      )}
      <div style={{ transition: 'transform 0.15s', transform: active ? 'scale(1.1)' : 'scale(1)' }}>
        {icon(active)}
      </div>
      <span>{label}</span>
    </button>
  );
}
